import axios from '../../utils/axios.js'

export const query = (query) => axios.setAxiosGetPromise('data', query)

export const downloads = (query) => axios.setAxiosGetPromise('message/v1/downloadsByDay')

export const top10 = (query) => axios.setAxiosGetPromise('data/top10', query)

export const usersCount = (query) => axios.setAxiosGetPromise('data/usersCount', query)

export const deviceStatistic = (query) => axios.setAxiosGetPromise('data/deviceStatistic', query)

export const pageViews = (query) => axios.setAxiosGetPromise('data/pageViews', query)



// WEBPACK FOOTER //
// ./src/services/system/data.js